const MuiDialogTitle = {
  styleOverrides: {
    root: {
      display: "flex",
      alignItems: "center",
    },
  },
};

export default MuiDialogTitle;
